import { MainV3ApiBase } from './base';
import { SubscriptionSuspension } from '../types/subscriptionSuspension';
import { Subscription, SubscriptionIndexView } from '../types/subscriptions';
import { ISODate } from '../../commonv3/types/dates';
import { SurveyKey } from './../../commonv3/types/surveys';

type SurveyAnswerParams = {
  survey_key: SurveyKey;
  parameters?: { [key: string]: string | number };
  answers: { [key: string]: string | string[] };
};

export type SubscriptionSuspensionRequest = {
  starts_at: ISODate;
  duration: number;
  survey_answers?: SurveyAnswerParams;
};

export const SubscriptionsApis = {
  base() {
    return MainV3ApiBase.appendPath('users/current/subscriptions');
  },
  findAll(): Promise<SubscriptionIndexView[]> {
    return this.base().get();
  },
  show(subscriptionCode: string): Promise<Subscription> {
    return this.base().withId(subscriptionCode).get();
  },
  suspend(subscriptionCode: string, request: SubscriptionSuspensionRequest): Promise<SubscriptionSuspension> {
    return this.base().withId(subscriptionCode).appendPath('subscription_suspensions').post(request);
  },
  cancel_suspend(subscriptionCode: string, subscriptionSuspensionCode: string) {
    return this.base()
      .withId(subscriptionCode)
      .appendPath('subscription_suspensions')
      .withId(subscriptionSuspensionCode)
      .delete();
  },
  resume_subscription(subscriptionCode: string) {
    return this.base().withId(subscriptionCode).appendPath('resume').put();
  },
};
